export const modernStyles = {
  borderRadius: "6px",
  fieldHeight: "40px",
  focusShadow: "0 0 0 2px rgba(51, 163, 255, 0.35)",
  hoverBorderColor: "hsl(var(--primary))",
  activeBorderColor: "hsl(var(--primary-foreground))",
  labelColor: "hsl(var(--foreground))",
  placeholderColor: "hsl(var(--foreground) / 0.6)",
  spacing: "16px",
  descriptionColor: "hsl(var(--foreground) / 0.8)",
  backgroundColor: "hsl(var(--primary))",
  hoveredBackgroundColor: "hsl(var(--primary-foreground))",
};
